<template>
  <div class="text-center">
    <div v-if="showCenter">
      <a href="https://www.hozehkh.com">
        <img class="logo" :src="require(`../../assets/logo.jpg`)" />
      </a>
    </div>
    <div class="searchPanelParent">
      <div :class="[showCenter ? 'searchPanelCenter' : 'searchPanelTop']" class="searchPanel">
        <v-row align="center">
          <v-col class="d-flex">
            <v-text-field outlined hide-details v-model="query" class="searchText" append-icon="mdi-magnify"
              v-on:keyup.enter="onSearchQuery" @click:append="onSearchQuery"
              placeholder="جستجو بر روی اسامی و سمت ها"></v-text-field>
          </v-col>
          <!-- <v-col class="d-flex" cols="3" md="2">
            <v-btn
              color="black--text"
              class="searchButton"
              rounded
              outlined
              @click="onSearchQuery"
            >
              جستجو
            </v-btn>
          </v-col> -->
        </v-row>
        <v-row align="center" class="buttonsRow">
          <v-col class="d-flex" cols="6" sm="3">
            <v-btn :color="getColor(1)" class="searchButton" rounded @click="selectType(1)">
              معاونت ها و دفاتر
            </v-btn>
          </v-col>
          <v-col class="d-flex" cols="6" sm="3">
            <v-btn :color="getColor(2)" class="searchButton" rounded @click="selectType(2)">
              مدیریت ها و مراکز
            </v-btn>
          </v-col>
          <v-col class="d-flex" cols="6" sm="3">
            <v-btn :color="getColor(3)" class="searchButton" rounded @click="selectType(3)">
              مدارس برادران
            </v-btn>
          </v-col>
          <v-col class="d-flex" cols="6" sm="3">
            <v-btn :color="getColor(4)" class="searchButton" rounded @click="selectType(4)">
              مدارس خواهران
            </v-btn>
          </v-col>
        </v-row>
        <div v-if="showCenter" class="addressButton">
          <a class="addressLink" href="https://www.hozehkh.com/Map/default.aspx">
            نشانی مدارس
          </a>
        </div>
        <!-- <v-btn
          v-if="showCenter"
          color="white primary--text"
          class="addressButton"
          rounded
          depressed
          @click="location.href = 'https://google.com'"
        >
          نشانی مدارس
        </v-btn> -->
      </div>
    </div>
    <div v-if="selectedType > 0">
      <div v-if="!showDetails" style="padding-bottom: 160px">
        <app-category v-for="index in filteredCategories.length" :key="index" :index="index - 1"
          :category="filteredCategories[index - 1]" :showDetails="false" @clicked="onClickCategory">
        </app-category>
      </div>
      <div v-else>
        <app-category :index="selectedCategory" :category="filteredCategories[selectedCategory]" :showDetails="true">
        </app-category>
      </div>
    </div>
    <div v-if="people.length > 0" style="padding-bottom: 160px">
      <div v-if="isMobile">
        <app-person v-for="index in people.length" :key="index" :index="index - 1" :person="people[index - 1]">
        </app-person>
      </div>
      <div v-else>
        <v-data-table :items="people" :headers="peopleHeaders" class="elevation-1 rounded" :footer-props="{
          itemsPerPageAllText: 'همه',
          itemsPerPageText: 'تعداد ردیف',
        }" :disable-pagination="true" :hide-default-footer="true">
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
          >
        </v-data-table>
      </div>
    </div>
    <div v-else-if="searchStatus == 2">موردی یافت نشد.</div>
    <div v-if="showCenter" class="footerLink"></div>
    <div class="footerAddress">
      <!-- <div class="footerLink">
        <a
          class="addressLink"
          href="https://www.hozehkh.com/Map/default.aspx"
          target="_blank"
        >
          نشانی مدارس
        </a>
      </div> -->
      <div class="addressText">
        <b>نشانی: </b>
        مشهد مقدس - بلوار شهیدشوشتری - انتهای شهید شوشتری هفت، کدپستی:
        9154656387، تلفن 05132008118، دورنگار 05132008900
      </div>
      <div class="itText">
        دفتر فناوری اطـلاعات مرکز مدیریت حـوزه علمیه خراســان
      </div>
    </div>
  </div>
</template>

<script>
import { getCategories, getContacts } from "@/api/contactus";
import Category from "./Category";
import Person from "./Person";
export default {
  data() {
    return {
      query: "",
      searchStatus: 0,
      selectedType: 0,
      categories: [],
      isLocal: false,
      people: [],
      selectedCategory: -1,
      peopleHeaders: [
        {
          text: "نام",
          value: "FName3",
          width: "25%",
        },
        {
          text: "سمت",
          value: "N_Chart",
          width: "50%",
        },
        {
          text: "تلفن",
          value: "Telphone",
          width: "25%",
        },
      ],
    };
  },
  components: {
    appCategory: Category,
    appPerson: Person,
  },
  computed: {
    filteredCategories() {
      return this.categories.filter((single) => {
        return single.typeChart == this.selectedType;
      });
    },
    showDetails() {
      return this.query !== "" || this.selectedCategory > -1;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    showCenter() {
      return this.selectedType == 0 && this.searchStatus == 0;
    },
  },
  created() {
    if (this.$route.query.index || this.$route.query.query) {
      this.$router.replace({
        query: {}
      })
    }
    this.getCategories();
  },
  methods: {
    selectType(type) {
      this.searchStatus = 0;
      this.selectedType = type;
      this.$router.push({

      });

      this.people = [];
    },
    getColor(type) {
      var color = "white--text";
      if (type != this.selectedType) {
        return color + " secondary";
      } else {
        return color + " orange";
      }
    },
    getCategories() {
      getCategories()
        .then((response) => {
          const data = response.data;
          this.categories = data.Categories;
          this.isLocal = data.IsLocal;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    onClickCategory(index) {
      window.scrollTo(0, 0);

      this.$router.push({
        query: {

          index: index
        }
      });
    },
    onSearchQuery() {
      if (this.query.trim() != "") {

        window.scrollTo(0, 0);

        this.$router.push({
          query: {

            query: this.query
          }
        });
      }
    },
    searchContacts() {
      this.searchStatus = 1;
      const srl_chart =
        this.selectedCategory != -1
          ? this.filteredCategories[this.selectedCategory].Srl_Chart
          : 0;
      getContacts(srl_chart, this.query)
        .then((response) => {
          const data = response.data;
          this.searchStatus = 2;
          this.people = data;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
  },
  watch: {

    '$route'(to, from) {
      const newIndex = this.$route.query.index ?? -1;
      const query = this.$route.query.query ?? "";

      if (newIndex > -1) {
        this.query = ""
        this.selectedCategory = newIndex
      } else if (query !== "") {
        this.selectedType = 0;
        this.selectedCategory = -1;
        this.query = query
      } else {
        this.selectedCategory = newIndex
        this.query = query
      }
      if (this.showDetails)
        this.searchContacts()
      else {
        this.searchStatus = 0;
        this.people = [];
      }

    }
  },

};
</script>
<style scoped>
.searchPanelCenter {
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.searchPanelTop {
  position: relative;
}

.searchPanel {
  padding: 30px;
  width: 100%;
}

.searchText {
  border-radius: 25px;
}

.logo {
  max-width: 80%;
  max-height: 25%;
  position: fixed;

  top: 7%;
  left: 50%;
  background-size: cover;
  -webkit-transform: translate(-50%, 0);
  transform: translate(-50%, 0);
}

@media screen and (min-width: 600px) {
  .logo {
    top: 12%;
  }
}

@media screen and (max-height: 700px) {
  .logo {
    top: 3%;
  }
}

@media screen and (min-width: 900px) {
  .searchPanel {
    width: 70%;
  }

  .searchPanelTop {
    right: 15%;
  }
}

@media screen and (min-width: 1264px) {
  .searchPanel {
    width: 60%;
  }

  .searchPanelTop {
    right: 20%;
  }
}

.searchButton {
  vertical-align: middle;
  width: 100%;
}

.footerAddress {
  position: fixed;
  bottom: 0;
  z-index: 2;

  width: 100%;
  text-align: right;
  line-height: 2;
  text-align: justify;
  color: white;
  background-color: darkslategrey;
  padding: 25px;
}

.itText {
  color: lightgray;
  text-align: center;
  margin-top: 10px;
  font-size: 13px;
}

.footerLink {
  text-align: left;
  padding-left: 25px;
  padding-bottom: 10px;
}

.addressButton {
  width: unset;
  margin-top: 30px;
}

.addressLink {
  text-decoration: none;
}

.buttonsRow {
  margin-top: 24px !important;
}
</style>
